if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            // Re-trigger Wishlist Suite / app block initialization for Quick View modal content
            setTimeout(() => {
              try {
                if (window.wishlistManager) {
                  if (typeof window.wishlistManager.init === 'function') window.wishlistManager.init();
                  if (typeof window.wishlistManager.render === 'function') window.wishlistManager.render();
                  if (typeof window.wishlistManager.renderButtons === 'function') window.wishlistManager.renderButtons();
                }
                if (window.wls && typeof window.wls.init === 'function') window.wls.init();
                if (window.WishlistSuite && typeof window.WishlistSuite.init === 'function') window.WishlistSuite.init();
              } catch (e) {}
              window.dispatchEvent(new Event('DOMContentLoaded'));
              window.dispatchEvent(new CustomEvent('wishlist:init'));
              window.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { modal: this, productElement } }));
            }, 50);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

/* Quick View Image Zoom Lightbox handler */
if (!window.quickAddZoomInitialized) {
  window.quickAddZoomInitialized = true;
  document.addEventListener('click', function(e) {
    const mediaOpener = e.target.closest('quick-add-modal .product__media, quick-add-modal .product__modal-opener, quick-add-modal .product__media-icon, quick-add-modal .product__media img');
    if (!mediaOpener) return;

    const img = mediaOpener.matches('img') ? mediaOpener : mediaOpener.querySelector('img');
    if (!img) return;

    e.preventDefault();
    e.stopPropagation();

    let zoomModal = document.getElementById('QuickAddImageZoomModal');
    if (!zoomModal) {
      zoomModal = document.createElement('div');
      zoomModal.id = 'QuickAddImageZoomModal';
      zoomModal.className = 'quick-add-zoom-modal';
      zoomModal.innerHTML = `
        <div class="quick-add-zoom-modal__backdrop"></div>
        <div class="quick-add-zoom-modal__content">
          <button type="button" class="quick-add-zoom-modal__close" aria-label="Close zoom">&times;</button>
          <div class="quick-add-zoom-modal__image-wrapper">
            <img src="" alt="" class="quick-add-zoom-modal__image" />
          </div>
        </div>
      `;
      document.body.appendChild(zoomModal);

      zoomModal.addEventListener('click', function(evt) {
        if (evt.target.classList.contains('quick-add-zoom-modal__backdrop') || evt.target.classList.contains('quick-add-zoom-modal__close')) {
          zoomModal.classList.remove('open');
          const zoomImg = zoomModal.querySelector('.quick-add-zoom-modal__image');
          if (zoomImg) zoomImg.classList.remove('zoomed');
        } else if (evt.target.classList.contains('quick-add-zoom-modal__image')) {
          evt.target.classList.toggle('zoomed');
        }
      });
    }

    const currentSrc = img.getAttribute('src') || img.currentSrc || '';
    const highResSrc = currentSrc.replace(/width=\d+/, 'width=1600').replace(/_\d+x\d*/, '');
    const zoomImg = zoomModal.querySelector('.quick-add-zoom-modal__image');
    zoomImg.src = highResSrc;
    zoomImg.alt = img.alt || '';
    zoomImg.classList.remove('zoomed');
    zoomModal.classList.add('open');
  });
}
